import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import UserMenu from './UserMenu';
import TenantSwitcher from './TenantSwitcher';
import logoWhite from '../assets/images/altvia-logo-white.svg';
import logoBlack from '../assets/images/altvia-logo-black.svg';

const BottomMenu = ({ user, tenants }) => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';
	const logo = isDark ? logoWhite : logoBlack;
	return (
		<AppBar
			position='fixed'
			elevation={0}
			sx={{
				top: 'auto',
				height: '64px',
				bottom: 0,
				zIndex: 1300,
				backgroundColor: theme.palette.background.paper,
				borderTopLeftRadius: '8px',
				borderTopRightRadius: '8px',
				borderBottomLeftRadius: 0,
				borderBottomRightRadius: 0,
			}}
		>
			<Toolbar
				sx={{
					color: theme.palette.text.primary,
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<Typography
						variant='h6'
						sx={{ flexGrow: 1, color: theme.palette.text.primary }}
					>
						<img
							src={logo}
							alt='Altvia Logo'
							style={{ height: '1.5rem', marginRight: '0.5rem' }}
						/>
						{/* ONE */}
					</Typography>
				</Box>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					{!user.tenant_id && <TenantSwitcher tenants={tenants} />}
					<UserMenu user={user} />
				</Box>
			</Toolbar>
		</AppBar>
	);
};

export default BottomMenu;
